if (!customElements.get("custom-video")) {
  class customVideo extends HTMLElement {
    constructor() {
      super();
      this.videoWrapper = this.querySelector('.td-video-wrapper');
      this.video = this.querySelector('video');
      this.playbutton = this.querySelector('.video-play-button');
      this.playing = false;
      this.blockId = this.getAttribute("data-block-id");
      this.autoplay = this.getAttribute("data-autoplay") || false;
      
      // Initialize intersection observer for scroll-based pausing
      this.intersectionObserver = null;
    }

    static currentlyPlayingVideo = null;

    connectedCallback() {
      if (this.video && this.playbutton && this.videoWrapper) {
        this.videoWrapper.addEventListener('click', () => this.handleVideoClick());
    
        // Listen for the custom event emitted from swiper-slider.js
        document.addEventListener('swiperSlideChanged', (evt) => {
          if (this.playing) {
            this.playbutton.style.display = "block";
            this.pauseVideo();
          } else if (this.autoplay == 'true' && this.blockId == evt.detail.slide_id) {
            this.playbutton.style.display = "none";
            this.playVideo();
          }
        });

        // Set up intersection observer to pause video when scrolled out of view
        this.setupIntersectionObserver();
      }
    }

    disconnectedCallback() {
      // Clean up intersection observer when element is removed
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }
    }

    setupIntersectionObserver() {
      // Create intersection observer to detect when video goes out of view
      this.intersectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            // If video is not intersecting (out of view) and is playing, pause it
            if (!entry.isIntersecting && this.playing) {
              this.pauseVideo();
              this.playbutton.style.display = "block";
            }
          });
        },
        {
          // Start observing when video is 20% out of view
          threshold: 0.2,
          // Use root margin to create a buffer zone
          rootMargin: '0px 0px -20% 0px'
        }
      );

      // Start observing the video wrapper
      if (this.videoWrapper) {
        this.intersectionObserver.observe(this.videoWrapper);
      }
    }

    handleVideoClick() {
      if (customVideo.currentlyPlayingVideo && customVideo.currentlyPlayingVideo !== this) {
        customVideo.currentlyPlayingVideo.pauseVideo();
      }

      if (this.playing) {
        this.playbutton.style.display = "block";
        this.pauseVideo();
      } else {
        this.playbutton.style.display = "none";
        this.playVideo();
      }
    }

    playVideo() {
      this.video.play().catch(e => console.error('Error attempting to play video:', e));
      this.playing = true;
      customVideo.currentlyPlayingVideo = this;
    }

    pauseVideo() {
      this.video.pause();
      this.playing = false;
      customVideo.currentlyPlayingVideo = null;
    }
  }

  customElements.define("custom-video", customVideo);
}
